import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import { Grid } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { t } from "i18next";
import React, { useEffect, useState } from "react";

import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import useAPI from "hooks/useAPI";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Skeleton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import moment from "moment";
import { Link } from "react-router-dom";
import KafkaData from "./data";

const ColorBar = styled("div")(({ status }) => ({
  width: "0.5rem",
  height: "2.5rem",
  position: "absolute",
  left: "10px",
  top: "50%",
  transform: "translateY(-50%)",
  backgroundColor: status === "running" ? "rgba(49,196,141,1)" : "rgba(249,128,128,1)",
  borderRadius: "25px",
}));

const theme = createTheme({});

const tableStyles = {
  borderRadius: "8px",
  boxShadow: 3,
  overflow: "hidden",
};

const headerStyles = {
  backgroundColor: "#f5f5f5",
  height: "50%",
  "& .MuiTableCell-root": {
    padding: "8px 16px",
    fontSize: "0.875rem",
  },
};

const KafkaDetails = () => {
  const { swm_api } = useAPI();
  const [kafkaData, setKafkaData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchKafkaData = async () => {
      try {
        const { data } = await swm_api.get("get-kafka-details/");
        setKafkaData(data);
      } catch (error) {
        console.error("Error fetching Kafka data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchKafkaData();
  }, []);

  const pagesList = [
    {
      name: t("lang.dashboard"),
      route: "/",
    },
    {
      name: t("lang.kafka"),
      route: "",
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar pagesList={pagesList} />
      <KafkaData isIframe={false} />
    </DashboardLayout>
  );
};

export default KafkaDetails;
